export interface FontTypeOption {
    id: string;
    label: string;
}

export const fontOptions: FontTypeOption[] = [
    { id: 'open-sans', label: 'Open Sans' },
    { id: 'times-new-roman', label: 'Times New Roman' },
    { id: 'arial', label: 'Arial' },
    { id: 'verdana', label: 'Verdana' },
    { id: 'comic-sans', label: 'Comic Sans' },
];
